import React from "react";
import { useTranslation } from "react-i18next";

const PageHeader = (props) => {
  const [t] = useTranslation();

  return (
    <div className="listPage-headerDiv">
      <p className="listPage-header">{t(props.header)}</p>
    </div>
  );
};

export default PageHeader;
